import React from "react";
import moment from "moment";
import clsx from "clsx";

import BookkeepingService, { PERIOD_LENGTH_OPTIONS, CUSTOM_PERIOD_LENGTH } from "../../../../services/BookkeepingService";

import WComponent from "../../../common/WComponent";
import DateSelector from "../../../common/date_selector/DateSelector";

class FiscalPeriodFields extends WComponent {
	onPeriodEndSelect = date => {
		this.props.onDraftChange({ periodEnd: moment(date).format("YYYY-MM-DD") });
	};

	onPeriodStartSelect = date => {
		this.props.onDraftChange({ periodStart: moment(date).format("YYYY-MM-DD") });
	};

	onLengthSelect = lengthMonths => {
		this.props.onDraftChange({ lengthMonths });
	};

	renderLengthChoice = () => {
		const { lengthMonths, radioGroupName } = this.props;
		return (
			<div className="bk-period__length">
				<div className="bk-period__length-label">Period length</div>
				<div className="bk-period__length-options">
					{PERIOD_LENGTH_OPTIONS.map(option => (
						<label key={option.value} className="bk-period__length-option">
							<input
								type="radio"
								name={radioGroupName}
								className="bk-period__length-radio"
								checked={lengthMonths === option.value}
								onChange={() => this.onLengthSelect(option.value)}
							/>
							{option.label}
						</label>
					))}
				</div>
			</div>
		);
	};

	render() {
		const { periodEnd, periodStart, lengthMonths, errorText, className } = this.props;
		const needsItsOwnStart = lengthMonths === CUSTOM_PERIOD_LENGTH;

		const derived = periodEnd
			? BookkeepingService.derivePeriodFromYearEnd({ fiscalYearEnd: periodEnd, periodLengthMonths: lengthMonths, periodStartOverride: periodStart })
			: null;
		const isDerived = derived && !derived.error;
		const previewText = isDerived
			? `${moment(derived.periodStart).format("MMM D, YYYY")} – ${moment(derived.periodEnd).format("MMM D, YYYY")}`
			: null;

		let consequenceText = null;
		if (isDerived && derived.periodType !== "annual") {
			consequenceText = "Interim period — statements are headed “Period ended” and no capital cost allowance is claimed.";
		} else if (isDerived && derived.isShortTaxYear) {
			consequenceText = `Short tax year — capital cost allowance is prorated ${derived.daysInPeriod}/365 and statements are headed “Period ended”.`;
		}

		return (
			<div className={clsx("bk-period", className)}>
				<DateSelector
					title="Period end"
					selectedDate={periodEnd ? new Date(`${periodEnd}T00:00:00`) : undefined}
					onDateSelect={this.onPeriodEndSelect}
				/>

				{this.renderLengthChoice()}

				{needsItsOwnStart && (
					<DateSelector
						title="Period start"
						selectedDate={periodStart ? new Date(`${periodStart}T00:00:00`) : undefined}
						onDateSelect={this.onPeriodStartSelect}
					/>
				)}

				{previewText && <div className="bk-wizard__success-box">{previewText}</div>}
				{consequenceText && <div className="bk-wizard__success-box bk-wizard__success-box--amber">{consequenceText}</div>}
				{errorText && <div className="bk-wizard__error-box">{errorText}</div>}
			</div>
		);
	}
}

export default FiscalPeriodFields;
